import { Context } from 'forms-ai-lib/internal/providers/ReduxStoreProvider';
import { createDispatchHook, createSelectorHook, createStoreHook } from 'react-redux';
export const useStore = createStoreHook(Context);
export const useDispatch = createDispatchHook(Context);
export const useSelector = createSelectorHook(Context);